<div [formGroup]="formGroup()" data-testid="staff-assigned-to-container">
  <!-- (click)="onClickStaff($event)"      -->
  @if (staffs$ | async; as staffs) {
    <p-select
      optionLabel="name"
      tooltip="{{ controlName().value?.name }}"
      appendTo="body"
      tooltipStyleClass="text-xs"
      tooltipPosition="bottom"
      [filter]="true"
      filterBy="name"
      (onChange)="onSelectStaff(SelectedStaff)"
      placeholder="{{ placeHolder() }}"
      styleClass="{{ styleClass() }}"
      [options]="staffs"
      [formControl]="controlName()"
      [resetFilterOnHide]="true"
      [showClear]="showClear()"
      [scrollHeight]="'200px'"
      aria-label="staff-dropdown"
      data-testid="staff-dropdown"
    >
      <ng-template pTemplate="selectedItem">
        @if (controlName().value) {
          <div
            class="flex align-items-center justify-content-between"
            data-testid="selected-staff-container"
          >
            <span class="w-2rem absolute left-0 ml-1">
              @if (controlName().value.ff_picture) {
                <p-avatar
                  [image]="controlName().value.ff_picture"
                  class="h-full"
                  aria-label="staff-avatar"
                  data-testid="staff-avatar"
                />
              } @else {
                <p-avatar
                  styleClass="text-sm w-2rem h-2rem mr-2"
                  label="{{
                    controlName().value.name ||
                      controlName().value.name_primary_language
                      | titlecase
                      | shortName
                  }}"
                  aria-label="staff-avatar-initials"
                  data-testid="staff-avatar-initials"
                />
              }
            </span>
            <strong
              class="text-900 ml-5 pl-1 md:w-7rem overflow-hidden text-overflow-ellipsis"
              data-testid="selected-staff-name"
              >{{ controlName().value.name }}</strong
            >
          </div>
        }
      </ng-template>
      <ng-template let-staffs pTemplate="item">
        <div
          class="assigned-item flex align-items-center my-2"
          data-testid="staff-list-item"
        >
          <span class="w-2rem absolute left-0 ml-3">
            @if (staffs.ff_picture) {
              <p-avatar
                [image]="staffs.ff_picture"
                class="mt-1"
                aria-label="staff-list-avatar"
                data-testid="staff-list-avatar"
              />
            } @else {
              <p-avatar
                styleClass="text-sm w-2rem h-2rem mr-2"
                label="{{ staffs.name | titlecase | shortName }}"
                aria-label="staff-list-avatar-initials"
                data-testid="staff-list-avatar-initials"
              />
            }
          </span>
          <div
            class="text-sm ml-5 w-6rem md:md:w-7rem overflow-hidden text-overflow-ellipsis"
            data-testid="staff-list-name"
          >
            {{ staffs.name }}
          </div>
        </div>
      </ng-template>
    </p-select>
  }
</div>
